import { render, staticRenderFns } from "./StepQuestionLayout.vue?vue&type=template&id=fac65b2e&scoped=true&"
import script from "./StepQuestionLayout.vue?vue&type=script&lang=js&"
export * from "./StepQuestionLayout.vue?vue&type=script&lang=js&"
import style0 from "./StepQuestionLayout.vue?vue&type=style&index=0&id=fac65b2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac65b2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VWindow } from 'vuetify/lib/components/VWindow';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VAlert,VCol,VContent,VRow,VWindow,VWindowItem})
